import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class NotificationTaskChangedStatusMeta extends BaseEntityModel {
  parentId?: string;
  oldStatus?: string;
  newStatus?: string;

  constructor(model: Partial<NotificationTaskChangedStatusMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.oldStatus = model.oldStatus;
    this.newStatus = model.newStatus;
  }
}
